var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShapeHisto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 132,
    height: 277,
    viewBox: "0 0 132 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_335",
    "data-name": "Rectangle 335",
    width: 132,
    height: 277,
    transform: "translate(1788 3630)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shape-histo",
    transform: "translate(-1788 -3630)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2680",
    "data-name": "Groupe 2680",
    transform: "matrix(0.719, 0.695, -0.695, 0.719, 19427.963, 7239.458)",
    opacity: 0.453
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1900",
    "data-name": "Ellipse 1900",
    cx: 117.286,
    cy: 117.286,
    rx: 117.286,
    ry: 117.286,
    transform: "translate(-15190.967 9709.367) rotate(-60)",
    fill: "rgba(255,208,138,0.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M197.167,21.712c23.416,23.491,21.023,60.7,19.04,93.806-1.745,29.121-10.722,56.472-29.386,78.893-19.912,23.921-44.938,48.3-76.057,47.776-30.351-.509-51.876-27.311-71.749-50.256-17.139-19.789-26.866-42.954-31.32-68.751C2.273,91.787-8.155,56.557,11.281,31.315,31.492,5.067,68.811,2.55,101.894.84,135.646-.9,173.307-2.224,197.167,21.712Z",
    transform: "translate(-14973.375 9818.195) rotate(-135)",
    fill: "#00e1f0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeHisto);
export default __webpack_public_path__ + "static/media/shape-histo.346704c99048a793b2812a3989354881.svg";
export { ForwardRef as ReactComponent };